import setLocalStorage from '@/app/utils/setLocalStorage';
import getLocalStorage from '@/app/utils/getLocalStorage';
import hashCode from '@/app/utils/hashCode';

(function (jQuery) {
  jQuery.gfTooltipsNew = function (element, options) {
    const defaults = {
      style: 'base',
      type: 'hover',
      title: 'Title default',
      desc: 'A section is a layout element (a "div block") with a width of 100%, so it extends across the full width of the browser window. It\'s perfect for full-screen background images, videos, and other content.',
      template: '',
      closer: '.closer',
      class: '',
      timeIn: 400,
      timeOut: 1000,
      width: '',
      height: '',
      postion: 'bottom',
      postionLeft: 0,
      postionTop: 0,
      backgroundColor: '#333',
      subTop: 0,
      subLeft: 0,
      arrowPostionLeft: '',
      arrowPostionTop: '',
      textPrimary: 'Okay, I got that!',
      isHover: false,
      onClickPrimary: function () {},
      onStop: function (force) {},
    };

    this.settings = {};
    const $element = jQuery(element);
    const $container = jQuery('#gfTooltipsNew');
    const _this = this;

    this._hashCode = hashCode;
    this._setLocalStorage = setLocalStorage;
    this._getLocalStorage = getLocalStorage;

    let $_target;
    let $_toolTips;
    let _time;
    let _delayRemoveTemplate;
    let _isHover;
    let _delayFadeOut;
    let _delayShow;

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      $_target = $element;

      _this.applyEvent();
      return false;
    };

    this.setOptions = function (options) {
      this.settings = jQuery.extend({}, defaults, _this.settings, options);
    };

    this.applyEvent = function () {
      if (_this.settings.type === 'hover' && _this.settings.style !== 'box') {
        $_target.off('mouseenter.gftooltipsnew').on('mouseenter.gftooltipsnew', function (e) {
          if (_isHover === true && $_toolTips) {
            $_toolTips.fadeIn(300);
            clearTimeout(_delayRemoveTemplate);
            clearTimeout(_delayFadeOut);
          }
          _delayShow = setTimeout(function () {
            _this.setTemplate();
          }, _this.settings.timeIn);
        });
      }
      if (_this.settings.type === 'hover' && _this.settings.style !== 'box') {
        $_target.off('mouseleave.gftooltipsnew').on('mouseleave.gftooltipsnew', function (e) {
          clearTimeout(_delayShow);
          _this.removeTemplate();
        });
      }
      if (_this.settings.type === 'click' && _this.settings.style === 'box') {
        $_target.off('click.gftooltipsnew').on('click.gftooltipsnew', function (e) {
          if (_isHover === true && $_toolTips) {
            $_toolTips.fadeIn(300);
            clearTimeout(_delayRemoveTemplate);
            clearTimeout(_delayFadeOut);
          }
          _delayShow = setTimeout(function () {
            _this.setTemplate();
          }, _this.settings.timeIn);
        });
      }
    };

    this.setTemplate = function () {
      if (!_isHover || _this.settings.isHover) {
        // Style arrow
        let styleArrow = '';
        if (_this.settings.arrowPostionTop) {
          styleArrow += 'top:' + _this.settings.arrowPostionTop + ';';
        }
        if (_this.settings.arrowPostionLeft) {
          styleArrow += 'left:' + _this.settings.arrowPostionLeft + ';';
        }
        if (_this.settings.backgroundColor) {
          styleArrow += 'border-top-color:' + _this.settings.backgroundColor + ';';
        }
        if (styleArrow) {
          styleArrow = 'style="' + styleArrow + '"';
        }

        // Style Item box
        let styleItem = '';
        if (_this.settings.width) {
          styleItem += 'width:' + _this.settings.width + ';';
        }
        if (_this.settings.height) {
          styleItem += 'height:' + _this.settings.height + ';';
        }
        if (_this.settings.postionTop) {
          styleItem += 'top:' + _this.settings.postionTop + ';';
        }
        if (_this.settings.postionLeft) {
          styleItem += 'left:' + _this.settings.postionLeft + ';';
        }
        if (_this.settings.backgroundColor) {
          styleItem += 'background-color:' + _this.settings.backgroundColor + ';';
        }
        if (styleItem) {
          styleItem = 'style="' + styleItem + '"';
        }

        // Style default tooltips
        var template =
          '<div class="gfTooltipsItem" ' +
          styleItem +
          ' data-postion="' +
          _this.settings.postion +
          '">' +
          _this.settings.desc +
          '<span class="gfTooltipsItemArrow" ' +
          styleArrow +
          ' data-postion="' +
          _this.settings.arrowPostion +
          '"></span></div>';

        // Style box
        if (_this.settings.style == 'box') {
          var template =
            '<div class="gfTooltipsItemBox" ' +
            styleItem +
            ' data-postion="' +
            _this.settings.postion +
            '"> <div class="gfTooltipsItemTitle">' +
            _this.settings.title +
            '</div>' +
            _this.settings.desc +
            '<span class="gfTooltipsItemClose"> <svg viewBox="0 0 320 512"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" class=""></path></svg> </span> <span class="gfTooltipsItemArrow" ' +
            styleArrow +
            ' data-postion="' +
            _this.settings.arrowPostion +
            '"></span> <div class="gfTooltipsItemButton"> <span class="ok">' +
            _this.settings.textPrimary +
            '</span></div></div>';
        }

        if (_this.settings.style == 'custom') {
          template =
            `<div class="gfTooltipsItemBox ${_this.settings.class}" ${styleItem} " data-postion="${_this.settings.postion}">` +
            _this.settings.template +
            `<span class="gfTooltipsItemClose">` +
            `<svg viewBox="0 0 320 512">` +
            `<path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" class=""></path>` +
            '</svg>' +
            '</span>' +
            `<span class="gfTooltipsItemArrow" ${styleArrow} data-postion="${_this.settings.arrowPostion}"></span>` +
            '</div>';
        }

        $_toolTips = jQuery(template);
        $container.append($_toolTips);
        _isHover = true;

        /*------------------- Tính toán vị trí ----------------*/
        const targetTop = $_target.offset().top;
        const targetLeft = $_target.offset().left;
        const targetHeight = $_target.outerHeight();
        const targetWidth = $_target.outerWidth();
        const toolTipsHeight = $_toolTips.outerHeight(true);
        const toolTipsWidth = $_toolTips.outerWidth(true);

        if (_this.settings.postionLeft) {
          var left = _this.settings.postionLeft;
        } else {
          // Căn giữa: Vị trí hiện tại + 1 nửa chiều rộng dom - 1 nữa độ rộng tooltip hiện tại
          var left = targetLeft + targetWidth / 2 - toolTipsWidth / 2;
          switch (_this.settings.postion) {
            case 'left':
              // Căn trái: Vị trí hiện tại - độ rộng tooltip hiện tại - Chiều rộng của mũi tên
              left = targetLeft - toolTipsWidth - 8;
              break;
            case 'right':
              // Căn trái: Vị trí hiện tại + độ rộng tooltip hiện tại + Chiều rộng của mũi tên
              left = targetLeft + toolTipsWidth + 8;
              break;
          }
        }

        if (left < 0) {
          left = 0;
          $_toolTips.find('.gfTooltipsItemArrow').css({
            left: targetLeft + targetWidth / 2,
          });
        }

        if (_this.settings.postionTop) {
          var top = _this.settings.postionTop;
        } else {
          // Nếu ở phía dưới: Vị trí hiện tại + chiều cao của dom + Chiều cao của mũi tên
          var top = targetTop + targetHeight + 8;
          switch (_this.settings.postion) {
            case 'top':
              // Nếu ở trên: Vị trí phía trên - Chiều cao của tooltip - chiều cao của mũi tên;
              top = targetTop - toolTipsHeight - 8;
              break;
            case 'left':
            case 'right':
              top = targetTop + targetHeight / 2 - toolTipsHeight / 2;
              break;
          }
        }

        $_toolTips.css({
          top: top - _this.settings.subTop,
          left: left - _this.settings.subLeft,
        });

        if (_this.settings.style == 'box') {
          $_toolTips
            .find('.gfTooltipsItemClose')
            .off('click.closeTooltips')
            .on('click.closeTooltips', function () {
              _this.stop();
            });

          $_toolTips
            .find('.gfTooltipsItemButton .ok')
            .off('click.closeTooltips')
            .on('click.closeTooltips', function () {
              _this.settings.onClickPrimary();

              try {
                let hashCurrent = _this._hashCode(_this.settings.title + _this.settings.desc);
                hashCurrent = 'tooltips_count_' + hashCurrent;
                let numberCurrent = parseInt(_this._getLocalStorage(hashCurrent));
                if (isNaN(numberCurrent)) {
                  numberCurrent = 1;
                } else {
                  numberCurrent = numberCurrent + 1;
                }
                _this._setLocalStorage(hashCurrent, numberCurrent);
              } catch (error) {
                console.log(error);
              }

              _this.stop();
            });
        }

        if (_this.settings.style == 'custom') {
          $_toolTips
            .find('.gfTooltipsItemClose')
            .off('click.closeTooltips')
            .on('click.closeTooltips', function () {
              _this.stop();
            });
          $_toolTips
            .find(_this.settings.closer)
            .off('click.closeTooltips')
            .on('click.closeTooltips', function () {
              _this.stop();
            });
        }
      }
    };

    this.removeTemplate = function () {
      // return;
      clearTimeout(_delayRemoveTemplate);
      clearTimeout(_delayFadeOut);
      if (_this.settings.isHover) {
        return;
      }
      if ($_toolTips && $_toolTips.length > 0) {
        _delayFadeOut = setTimeout(function () {
          $_toolTips.fadeOut(_this.settings.timeOut / 2);
        }, _this.settings.timeOut / 2);
        _delayRemoveTemplate = setTimeout(function () {
          _isHover = false;
          $_toolTips.remove();
        }, _this.settings.timeOut);
      }
    };

    this.start = function () {
      // style Box
      const hashCurrent = _this._hashCode(_this.settings.title + _this.settings.desc);
      checkHashCurrent = 'tooltips_' + hashCurrent;
      var hashCurrentInLocalStorage = _this._getLocalStorage(checkHashCurrent);
      if (hashCurrentInLocalStorage && hashCurrentInLocalStorage == 'true') {
        // stop
        _this.settings.onStop(true);
        return false;
      }

      var checkHashCurrent = 'tooltips_count_' + hashCurrent;
      var hashCurrentInLocalStorage = parseInt(_this._getLocalStorage(checkHashCurrent));
      if (hashCurrentInLocalStorage && !isNaN(hashCurrentInLocalStorage) && hashCurrentInLocalStorage >= 2) {
        // stop
        _this.settings.onStop(true);
        return false;
      }

      _this.setTemplate();
      return false;
    };

    this.stop = function () {
      $_target.off('mouseenter.gftooltipsnew');
      $_target.off('mouseleave.gftooltipsnew');
      clearTimeout(_delayRemoveTemplate);
      clearTimeout(_delayFadeOut);
      clearTimeout(_delayShow);
      if ($_toolTips && $_toolTips.length > 0) {
        $_toolTips.remove();
      }

      $element.removeData('gftooltipsnew');
      _this.settings.onStop();
    };

    this.setDesc = function (value) {
      if (_this.settings) {
        _this.settings.desc = value;
      }
    };

    this.init();
  };

  jQuery.fn.gfTooltipsNew = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gftooltipsnew')) {
        const plugin = new jQuery.gfTooltipsNew(this, options);
        jQuery(this).data('gftooltipsnew', plugin);
      }
    });
  };
})(jQuery);
